import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-单选",
  "use": "icon-单选-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-单选\">\n  <g id=\"icon-单选_单选\" transform=\"translate(0 -7.076)\">\n    <g id=\"icon-单选_RadioButton_pressed\" transform=\"translate(0 7.076)\">\n      <g id=\"icon-单选_矩形_664\" data-name=\"矩形 664\" fill=\"none\" stroke=\"#3b86ff\" stroke-width=\"2\">\n        <rect width=\"30\" height=\"30\" rx=\"15\" stroke=\"none\" />\n        <rect x=\"1\" y=\"1\" width=\"28\" height=\"28\" rx=\"14\" fill=\"none\" />\n      </g>\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol